import React from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "semantic-ui-react";

import { supportForUserPath, cancelGrSupportForUserPath } from "routes";
import { AdminContainer } from "./styled";
import { MenuButton } from "../styled";
import { MainBodyContent } from "components";

const SupportGRMainContainer = (props) => {
  const {
    history
  } = props;
  return (
    <MainBodyContent
      headerTitle="Good/Service Receipt (GR)"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {history.push(supportForUserPath)},
            },
            { key: "gr", content: "Good/Service Receipt (GR)", active: true },
          ]}
        />
      }
    >
      <AdminContainer>
        <MenuButton title="Cancel GR" onClick={() => history.push(cancelGrSupportForUserPath)} />
      </AdminContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportGRMainContainer);
